// Derives a compact "step X of N" progress from dispute-level fields only
// (no message thread needed), so it can be used on list/card views.
export const DISPUTE_MILESTONES = [
  { key: 'opened', label: 'Dispute opened' },
  { key: 'provider_replied', label: 'Provider replied' },
  { key: 'evidence', label: 'Evidence uploaded' },
  { key: 'admin_assigned', label: 'Admin assigned' },
  { key: 'resolution', label: 'Resolution' },
  { key: 'closed', label: 'Closed' },
];

export function getDisputeProgress(dispute) {
  if (!dispute) return null;
  const status = dispute.status;
  const resubmissions = dispute.resubmission_count || 0;

  const done = {
    opened: true,
    provider_replied:
      ['in_progress', 'resubmitted', 'escalated', 'resolved', 'closed'].includes(status) || resubmissions > 0,
    evidence: resubmissions > 0 || status === 'resubmitted',
    admin_assigned: !!dispute.escalated_to_admin,
    resolution: !!dispute.resolved_at || !!dispute.resolution_type || ['resolved', 'closed'].includes(status),
    closed: !!dispute.closed_at || status === 'closed' || status === 'resolved',
  };

  // Furthest completed milestone (in order) = current progress step
  let step = 1;
  let label = DISPUTE_MILESTONES[0].label;
  DISPUTE_MILESTONES.forEach((m, i) => {
    if (done[m.key]) {
      step = i + 1;
      label = m.label;
    }
  });

  const total = DISPUTE_MILESTONES.length;
  return { step, total, label, percent: Math.round((step / total) * 100), done, complete: step === total };
}
